import { Alert, AlertTitle, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface RecalculationAlertProps {
    isRecalculating: boolean;
}

const RecalculationAlert: React.FC<RecalculationAlertProps> = ({ isRecalculating }) => {
    const { t } = useTranslation();

    if (!isRecalculating) {
        return null;
    }

    return (
        <Alert 
            severity="info" 
            sx={{
                mb: 2.5,
                bgcolor: 'background.paper',
                borderColor: 'divider',
                border: '1px solid',
                borderRadius: 2,
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                '& .MuiAlert-icon': {
                    alignSelf: 'flex-start',
                    mt: 0.5,
                },
            }}
            icon={
                <CircularProgress 
                    size={20} 
                    thickness={4}
                    sx={{ 
                        color: 'info.main',
                    }} 
                />
            }
        >
            <AlertTitle sx={{ fontWeight: 600, mb: 0.5 }}>
                {t('taxReports.recalculation.title')}
            </AlertTitle>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {t('taxReports.recalculation.description')}
            </Typography>
        </Alert>
    );
};

export default RecalculationAlert;
